// extracted by mini-css-extract-plugin
module.exports = {"question":"styles_question__ORLGe","imageDiv":"styles_imageDiv__1C5IH","correctAnswers":"styles_correctAnswers__39dd_"};